<template>
  <RegisterMain />
</template>

<script>
import RegisterMain from '@/components/RegisterMain'

export default {
  components: {
    RegisterMain
  }
}
</script>
